import type { Page } from "@inertiajs/core";

type FlashToasts = {
  success: (message: string) => void;
  error: (message: string) => void;
};

/**
 * Shows the session's `success` and `error` flash once. The server sends a flash with one full response, but the page
 * keeps it afterwards: a partial reload merges it into the next page and browser history restores it, so `dropFlash`
 * removes it once shown. One visit's navigate and success events carry the same page, which shows it only once.
 */
export const createFlashMessenger = (toasts: FlashToasts, dropFlash: () => void) => {
  const shownPages = new WeakSet<Page>();

  return (page: Page) => {
    const { success, error } = page.props as { success?: string | null; error?: string | null };

    if ((!success && !error) || shownPages.has(page)) {
      return;
    }

    shownPages.add(page);

    if (error) {
      toasts.error(error);
    }

    if (success) {
      toasts.success(success);
    }

    dropFlash();
  };
};
